import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlService } from '../../services/url.service';
import {
  ILoginResponse,
  ILoginRequest,
  ICategorySelectionStep,
} from './login.interface';

@Injectable()
export class LoginService extends UrlService {
  constructor(private http: HttpClient) {
    super();
  }

  login(payload: Partial<ILoginRequest>) {
    return this.http.post<ILoginResponse>(this.loginURL, payload, {
      observe: 'response',
    });
  }

  subcategoriesStep(
    accessToken: string,
  ): Observable<HttpResponse<ICategorySelectionStep[]>> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });
    return this.http.get<ICategorySelectionStep[]>(this.subcategoriesURL, {
      headers,
      observe: 'response',
    });
  }
}
